module.exports = __webpack_public_path__ + "static/thermal-c67dbd987ee583ae7bd7f4be1b080ef1.png";